import React from 'react';
import clsx from 'clsx';
import {
  IconButton,
  Button,
  Tooltip,
  Select,
  FormControl,
} from '@material-ui/core';
import {
  FaBold,
  FaItalic,
  FaUnderline,
  FaStrikethrough,
  FaAlignLeft,
  FaAlignCenter,
  FaAlignRight,
  FaAlignJustify,
  FaListUl,
  FaListOl,
  FaIndent,
  FaOutdent,
  FaUndo,
  FaRedo,
  FaTable,
  FaMinus,
  FaFileAlt,
  FaDownload,
} from 'react-icons/fa';

import { FORMATOS } from '../constantes';
import BarraContextualTabla from './BarraContextualTabla';
import MenuVariables from './MenuVariables';
import MenuTabla from './MenuTabla';
import ModalPersonalizarTabla from './ModalPersonalizarTabla';

const BarraHerramientas = ({
  classes,
  formatoActual,
  onCambiarFormato,
  formatosActivos,
  onEjecutarComando,
  onInsertarSaltoPagina,
  // Tablas
  estaEnTabla,
  estiloTablaActual,
  anchorTabla,
  onAbrirMenuTabla,
  onCerrarMenuTabla,
  onCambiarEstiloTabla,
  onInsertarFila,
  onEliminarFila,
  onInsertarColumna,
  onEliminarColumna,
  onEliminarTabla,
  onInsertarNuevaTabla,
  modalTablaOpen,
  onAbrirModalPersonalizar,
  onCerrarModalPersonalizar,
  configTabla,
  setConfigTabla,
  // Variables
  onInsertarVariable,
  onGuardarSeleccion,
  // Vista previa
  onDescargarVistaPrevia,
  descargandoVistaPrevia = false,
}) => {
  return (
    <div className={classes.toolbar}>
      {/* Historial */}
      <div className={classes.toolbarGroup}>
        <Tooltip title="Deshacer (Ctrl+Z)">
          <IconButton
            size="small"
            className={classes.iconButton}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onEjecutarComando('undo')}
          >
            <FaUndo size={13} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Rehacer (Ctrl+Y)">
          <IconButton
            size="small"
            className={classes.iconButton}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onEjecutarComando('redo')}
          >
            <FaRedo size={13} />
          </IconButton>
        </Tooltip>
      </div>

      {/* Tipo de bloque (Párrafo, Encabezados, Cláusula) */}
      <div className={classes.toolbarGroup}>
        <FormControl variant="outlined" size="small">
          <Select
            native
            value={formatoActual}
            onChange={onCambiarFormato}
            className={classes.selectFormat}
          >
            {FORMATOS.map((f) => (
              <option key={f.valor} value={f.valor}>
                {f.label}
              </option>
            ))}
          </Select>
        </FormControl>
      </div>

      {/* Estilos inline principales */}
      <div className={classes.toolbarGroup}>
        <Tooltip title="Negrita (Ctrl+B)">
          <IconButton
            size="small"
            className={clsx(classes.iconButton, { [classes.iconButtonActive]: formatosActivos.bold })}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onEjecutarComando('bold')}
          >
            <FaBold size={13} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Cursiva (Ctrl+I)">
          <IconButton
            size="small"
            className={clsx(classes.iconButton, { [classes.iconButtonActive]: formatosActivos.italic })}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onEjecutarComando('italic')}
          >
            <FaItalic size={13} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Subrayado (Ctrl+U)">
          <IconButton
            size="small"
            className={clsx(classes.iconButton, { [classes.iconButtonActive]: formatosActivos.underline })}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onEjecutarComando('underline')}
          >
            <FaUnderline size={13} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Tachado">
          <IconButton
            size="small"
            className={clsx(classes.iconButton, { [classes.iconButtonActive]: formatosActivos.strikeThrough })}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onEjecutarComando('strikeThrough')}
          >
            <FaStrikethrough size={13} />
          </IconButton>
        </Tooltip>
      </div>

      {/* Alineación */}
      <div className={classes.toolbarGroup}>
        <Tooltip title="Alinear a la izquierda">
          <IconButton
            size="small"
            className={clsx(classes.iconButton, { [classes.iconButtonActive]: formatosActivos.justifyLeft })}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onEjecutarComando('justifyLeft')}
          >
            <FaAlignLeft size={13} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Centrar">
          <IconButton
            size="small"
            className={clsx(classes.iconButton, { [classes.iconButtonActive]: formatosActivos.justifyCenter })}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onEjecutarComando('justifyCenter')}
          >
            <FaAlignCenter size={13} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Alinear a la derecha">
          <IconButton
            size="small"
            className={clsx(classes.iconButton, { [classes.iconButtonActive]: formatosActivos.justifyRight })}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onEjecutarComando('justifyRight')}
          >
            <FaAlignRight size={13} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Justificar">
          <IconButton
            size="small"
            className={clsx(classes.iconButton, { [classes.iconButtonActive]: formatosActivos.justifyFull })}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onEjecutarComando('justifyFull')}
          >
            <FaAlignJustify size={13} />
          </IconButton>
        </Tooltip>
      </div>

      {/* Listas y sangrías */}
      <div className={classes.toolbarGroup}>
        <Tooltip title="Lista con viñetas">
          <IconButton
            size="small"
            className={clsx(classes.iconButton, { [classes.iconButtonActive]: formatosActivos.insertUnorderedList })}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onEjecutarComando('insertUnorderedList')}
          >
            <FaListUl size={13} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Lista numerada">
          <IconButton
            size="small"
            className={clsx(classes.iconButton, { [classes.iconButtonActive]: formatosActivos.insertOrderedList })}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onEjecutarComando('insertOrderedList')}
          >
            <FaListOl size={13} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Reducir sangría">
          <IconButton
            size="small"
            className={classes.iconButton}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onEjecutarComando('outdent')}
          >
            <FaOutdent size={13} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Aumentar sangría">
          <IconButton
            size="small"
            className={classes.iconButton}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onEjecutarComando('indent')}
          >
            <FaIndent size={13} />
          </IconButton>
        </Tooltip>
      </div>

      {/* Tablas y separador */}
      <div className={classes.toolbarGroup}>
        <Tooltip title={estaEnTabla ? 'Opciones y formato de tabla (Activa)' : 'Insertar tabla'}>
          <IconButton
            size="small"
            className={clsx(classes.iconButton, estaEnTabla && classes.iconButtonActive)}
            onMouseDown={(e) => e.preventDefault()}
            onClick={onAbrirMenuTabla}
          >
            <FaTable size={13} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Línea horizontal">
          <IconButton
            size="small"
            className={classes.iconButton}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onEjecutarComando('insertHorizontalRule')}
          >
            <FaMinus size={13} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Salto de página (Ctrl+Enter)">
          <IconButton
            size="small"
            className={classes.iconButton}
            onMouseDown={(e) => e.preventDefault()}
            onClick={onInsertarSaltoPagina}
          >
            <FaFileAlt size={13} />
          </IconButton>
        </Tooltip>
      </div>

      {/* Barra contextual rápida cuando el cursor está dentro de una tabla */}
      {estaEnTabla && (
        <BarraContextualTabla
          classes={classes}
          estiloTablaActual={estiloTablaActual}
          onCambiarEstiloTabla={onCambiarEstiloTabla}
          onInsertarFila={onInsertarFila}
          onEliminarFila={onEliminarFila}
          onInsertarColumna={onInsertarColumna}
          onEliminarColumna={onEliminarColumna}
          onEliminarTabla={onEliminarTabla}
        />
      )}

      {/* Botón estelar: INSERTAR VARIABLE DINÁMICA */}
      <MenuVariables
        classes={classes}
        onInsertarVariable={onInsertarVariable}
        onGuardarSeleccion={onGuardarSeleccion}
      />

      {/* Botón: DESCARGAR VISTA PREVIA CON DUMMY DATA Y MARCA DE AGUA */}
      {onDescargarVistaPrevia && (
        <Tooltip title="Descargar documento actual como vista previa en Word con variables dummy y marca de agua">
          <span style={{ display: 'inline-flex', alignItems: 'center' }}>
            <Button
              size="small"
              variant="outlined"
              className={classes.btnVistaPreviaToolbar}
              onClick={onDescargarVistaPrevia}
              disabled={descargandoVistaPrevia}
              startIcon={<FaDownload size={11} />}
            >
              {descargandoVistaPrevia ? 'Generando...' : 'Descargar Vista Previa'}
            </Button>
          </span>
        </Tooltip>
      )}

      {/* Menú de Opciones y Formato de Tabla */}
      <MenuTabla
        classes={classes}
        anchorEl={anchorTabla}
        onClose={onCerrarMenuTabla}
        estaEnTabla={estaEnTabla}
        estiloTablaActual={estiloTablaActual}
        onCambiarEstiloTabla={onCambiarEstiloTabla}
        onInsertarFila={onInsertarFila}
        onEliminarFila={onEliminarFila}
        onInsertarColumna={onInsertarColumna}
        onEliminarColumna={onEliminarColumna}
        onEliminarTabla={onEliminarTabla}
        onInsertarNuevaTabla={onInsertarNuevaTabla}
        onAbrirModalPersonalizar={onAbrirModalPersonalizar}
      />

      {/* Diálogo para personalizar e insertar tabla */}
      <ModalPersonalizarTabla
        open={modalTablaOpen}
        onClose={onCerrarModalPersonalizar}
        configTabla={configTabla}
        setConfigTabla={setConfigTabla}
        onInsertar={onInsertarNuevaTabla}
      />
    </div>
  );
};

export default React.memo(BarraHerramientas);
